module.exports = __webpack_public_path__ + "img/facilityInfo_3_5.4868985a.jpg";